
 import Sidebar from "./Sidebar"
 import Header from "./Header"
 import React,{useState} from "react";
import CircularProgress from '@mui/material/CircularProgress';

   const Layout = ({children,message=null,setmessage=null, tipe = null, settipe = null}) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    return(
       <div className="min-h-screen bg-slate-50">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        <div className="lg:ml-96">
        <Header  onMenuClick={() => setSidebarOpen(true)} message={message} setmessage={setmessage}  tipe={tipe} settipe={settipe}/>

        <main className="p-8">
            {children}
          {/* <div className="mb-8">
            <h1 className="text-3xl font-bold text-slate-900 mb-2">Dashboard Overview</h1>
            <p className="text-slate-600">Welcome back! Here's what's happening with your business today.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            <StatCard
              title="Total Revenue"
              value="$45,231"
              change="+20.1%"
              isPositive={true}
              icon={DollarSign}
              iconColor="text-green-600"
              iconBg="bg-green-100"
            />
            <StatCard
              title="Total Customers"
              value="2,847"
              change="+12.5%"
              isPositive={true}
              icon={Users}
              iconColor="text-blue-600"
              iconBg="bg-blue-100"
            />
            <StatCard
              title="Total Orders"
              value="1,423"
              change="-3.2%"
              isPositive={false}
              icon={ShoppingBag}
              iconColor="text-orange-600"
              iconBg="bg-orange-100"
            />
            <StatCard
              title="Growth Rate"
              value="23.5%"
              change="+8.3%"
              isPositive={true}
              icon={TrendingUp}
              iconColor="text-cyan-600"
              iconBg="bg-cyan-100"
            />
          </div>

          <div className="mb-8">
            <ChartCard />
          </div>

          <div>
            <RecentActivity />
          </div> */}
        </main>
      </div>
    </div>

    //   <div className="min-h-screen w-full bg-white flex">
    //   <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        
    //   <div className="flex-1 lg:ml-0" style={{overflowY:"auto"}}>
    //     <div className="sticky top-0 z-50 bg-white shadow">
    //          <Header onMenuClick={() => setSidebarOpen(true)} message={message} setmessage={setmessage}  tipe={tipe} settipe={settipe}/>
    //     </div>
       
        
    //     <main className="p-4 lg:p-4"  >
    //       <div style={{width:"100%", position:"relative"}}>
    //          <div style={{width:"100%", position:"absolute"}}>
    //               {children}
    //         </div>
    //         </div>
             
    //     </main>
    //   </div>
    // </div>
  //       <body className="skin-blue">
            
  //       <div className="wrapper">
  //       <Sidebar />
  //       <div className="content-wrapper">
  //         <Header message={message} setmessage={setmessage}  tipe={tipe} settipe={settipe}/>
  //         <br></br>
  //           <main>
           
  //           {children}
             
  //           </main>
      
  //     </div>
  //  </div>
  //  </body>
  
  
    )
   
}
export default React.memo(Layout)